module.exports = __webpack_public_path__ + "img/steel-1.6d4cfc54.jpg";